import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { Map } from 'immutable';
import GenericSmallIconButton from 'flow/components/buttons/GenericSmallIconButton';
import ContactBox from 'flow/components/contact-card/ContactBoxTW';
import ContactInfoFields from 'flow/components/contact-card/ContactInfoFields';
import ContactInfoFieldsFallback from 'flow/components/contact-card/ContactInfoFieldsFallback';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { selectCallRecordContact, selectCallRecordFromKey } from 'flow/selectors/call-records-selectors';
import { getContact } from 'flow/selectors/contact-selectors';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import { isThirdPartyContactKey } from 'flow/utils';
import { getCountryCodeFromCallRecord } from 'flow/utils/call-records-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var ContactInfoCard = function ContactInfoCard(_ref) {
  var contactKey = _ref.contactKey,
    contact = _ref.contact,
    extensionKey = _ref.extensionKey,
    callRecordKey = _ref.callRecordKey,
    onNavigation = _ref.onNavigation,
    inactiveBgColor = _ref.inactiveBgColor;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var _useModal = useModal(),
    openModal = _useModal.openModal;
  var callRecord = useAppSelector(function (state) {
    return selectCallRecordFromKey(state, callRecordKey) || Map();
  });
  var ownCountryCode = useAppSelector(selectUserCountryCode);
  var extensionKeyContact = useAppSelector(function (state) {
    return getContact(state, contactKey, extensionKey);
  });
  var callRecordContact = useAppSelector(function (state) {
    return selectCallRecordContact(state, callRecordKey);
  });
  var contactToUse = contact || extensionKeyContact || callRecordContact;
  if (!contactToUse) {
    return null;
  }
  var handleEditContact = function handleEditContact() {
    onNavigation === null || onNavigation === void 0 || onNavigation();
    openModal('editContact', {
      contact: contactToUse
    });
  };
  var handleCreateContact = function handleCreateContact() {
    openModal('createContact', {
      contact: contact,
      countryCode: getCountryCodeFromCallRecord(callRecord) || ownCountryCode
    });
  };
  var isContactSaved = contactToUse.has('key') && !isThirdPartyContactKey(contactToUse.get('key'));
  var contactInfoFieldsProps = {
    contact: contactToUse,
    extensionKey: extensionKey
  };
  var getSetModalButton = function getSetModalButton() {
    if (isContactSaved && contactToUse.get('editable')) {
      return /*#__PURE__*/_jsx(GenericSmallIconButton, {
        onClick: handleEditContact,
        iconKey: 'edit',
        label: i18next.t('Tooltip.Nav.Title.Edit'),
        className: "bg-transparent text-gray-500",
        size: "small"
      });
    }
    if (!isContactSaved) {
      return /*#__PURE__*/_jsx(GenericSmallIconButton, {
        onClick: handleCreateContact,
        iconKey: 'add',
        label: i18next.t('Colleagues.Create.External.Title'),
        className: "bg-white text-gray-400",
        size: "small"
      });
    }
  };
  return /*#__PURE__*/_jsx(ContactBox, {
    headerTitle: i18next.t('Settings.Account.Contact'),
    setModalButton: getSetModalButton(),
    inactiveBgColor: inactiveBgColor,
    children: contactToUse.has('editableContactDTO') ? /*#__PURE__*/_jsx(ContactInfoFields, _objectSpread(_objectSpread({}, contactInfoFieldsProps), {}, {
      inactiveBgColor: inactiveBgColor
    })) : /*#__PURE__*/_jsx(ContactInfoFieldsFallback, _objectSpread({}, contactInfoFieldsProps))
  });
};
export default ContactInfoCard;